import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Col } from '@amzn/atoz-web/Col';
import { PageContainer } from '@amzn/atoz-web/PageContainer';
import { GenericErrorContent } from './GenericErrorContent.web';
export var GenericErrorPageLayout = function (_a) {
    var titleText = _a.titleText, textAlign = _a.textAlign, bodyText = _a.bodyText, buttonText = _a.buttonText, buttonAction = _a.buttonAction;
    var t = useTranslation().t;
    var titleString = titleText || t('ess_error_wrapper_message');
    var bodyString = bodyText || t('ess_error_wrapper_try_again');
    var buttonString = buttonText || t('ess_shifts_dashboard_errorModal_tryAgain');
    return (React.createElement(PageContainer, { dataTestId: "GenericErrorPageLayout" },
        React.createElement(Col, { gridGap: "S500", maxWidth: 500, margin: "0 auto" },
            React.createElement(GenericErrorContent, { titleText: titleString, textAlign: textAlign, bodyText: bodyString, buttonText: buttonString, onButtonClick: buttonAction }))));
};
